// extracted by mini-css-extract-plugin
module.exports = {"container":"warning_container__IAYGM","box-section":"warning_box-section__08hpL","title":"warning_title__b4hur","icon":"warning_icon__rDng7"};